import React from 'react';
import { createIcon } from 'components/shared/SVGIcon';

const ExportIcon = createIcon(
  'Export',
  <path d="M15.8348199,9.97343061 L14.5075076,9.97343061 L14.5075076,14.5039051 C14.5075076,15.0022573 14.1318532,15.41 13.67272,15.41 L10.3335697,15.41 C9.87443648,15.41 9.49878206,15.0022573 9.49878206,14.5039051 L9.49878206,9.97343061 L8.17146979,9.97343061 C7.42850884,9.97343061 7.05285442,8.99484812 7.5787706,8.42400834 L11.4104456,4.26503276 C11.7360128,3.91165575 12.261929,3.91165575 12.5874961,4.26503276 L16.4191712,8.42400834 C16.9450874,8.99484812 16.5777808,9.97343061 15.8348199,9.97343061 Z M5,18 C5,17.3583333 5.45,16.8333333 6,16.8333333 L18,16.8333333 C18.55,16.8333333 19,17.3583333 19,18 C19,18.6416667 18.55,19.1666667 18,19.1666667 L6,19.1666667 C5.45,19.1666667 5,18.6416667 5,18 Z" />
);

export default ExportIcon;
